import { SVGProps } from "react";

const GroupShape = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={349}
      height={283}
      fill="none"
      {...props}
    >
      <circle cx={2} cy={40} r={2} fill="currentColor" />
      <circle cx={16.75} cy={40} r={2} fill="currentColor" />
      <circle cx={31.5} cy={40} r={2} fill="currentColor" />
      <circle cx={46.25} cy={40} r={2} fill="currentColor" />
      <circle cx={61} cy={40} r={2} fill="currentColor" />
      <circle cx={2} cy={54.75} r={2} fill="currentColor" />
      <circle cx={16.75} cy={54.75} r={2} fill="currentColor" />
      <circle cx={31.5} cy={54.75} r={2} fill="currentColor" />
      <circle cx={46.25} cy={54.75} r={2} fill="currentColor" />
      <circle cx={61} cy={54.75} r={2} fill="currentColor" />
      <circle cx={2} cy={69.5} r={2} fill="currentColor" />
      <circle cx={16.75} cy={69.5} r={2} fill="currentColor" />
      <circle cx={31.5} cy={69.5} r={2} fill="currentColor" />
      <circle cx={46.25} cy={69.5} r={2} fill="currentColor" />
      <circle cx={61} cy={69.5} r={2} fill="currentColor" />
      <circle cx={2} cy={84.25} r={2} fill="currentColor" />
      <circle cx={16.75} cy={84.25} r={2} fill="currentColor" />
      <circle cx={31.5} cy={84.25} r={2} fill="currentColor" />
      <circle cx={46.25} cy={84.25} r={2} fill="currentColor" />
      <circle cx={61} cy={84.25} r={2} fill="currentColor" />
      <circle cx={2} cy={99} r={2} fill="currentColor" />
      <circle cx={16.75} cy={99} r={2} fill="currentColor" />
      <circle cx={31.5} cy={99} r={2} fill="currentColor" />
      <circle cx={46.25} cy={99} r={2} fill="currentColor" />
      <circle cx={61} cy={99} r={2} fill="currentColor" />
      <circle cx={179} cy={145} r={2} fill="currentColor" />
      <circle cx={193.75} cy={145} r={2} fill="currentColor" />
      <circle cx={208.5} cy={145} r={2} fill="currentColor" />
      <circle cx={223.25} cy={145} r={2} fill="currentColor" />
      <circle cx={238} cy={145} r={2} fill="currentColor" />
      <circle cx={179} cy={159.75} r={2} fill="currentColor" />
      <circle cx={193.75} cy={159.75} r={2} fill="currentColor" />
      <circle cx={208.5} cy={159.75} r={2} fill="currentColor" />
      <circle cx={223.25} cy={159.75} r={2} fill="currentColor" />
      <circle cx={238} cy={159.75} r={2} fill="currentColor" />
      <circle cx={179} cy={174.5} r={2} fill="currentColor" />
      <circle cx={193.75} cy={174.5} r={2} fill="currentColor" />
      <circle cx={208.5} cy={174.5} r={2} fill="currentColor" />
      <circle cx={223.25} cy={174.5} r={2} fill="currentColor" />
      <circle cx={238} cy={174.5} r={2} fill="currentColor" />
      <circle cx={179} cy={189.25} r={2} fill="currentColor" />
      <circle cx={193.75} cy={189.25} r={2} fill="currentColor" />
      <circle cx={208.5} cy={189.25} r={2} fill="currentColor" />
      <circle cx={223.25} cy={189.25} r={2} fill="currentColor" />
      <circle cx={238} cy={189.25} r={2} fill="currentColor" />
      <circle cx={179} cy={204} r={2} fill="currentColor" />
      <circle cx={193.75} cy={204} r={2} fill="currentColor" />
      <circle cx={208.5} cy={204} r={2} fill="currentColor" />
      <circle cx={223.25} cy={204} r={2} fill="currentColor" />
      <circle cx={238} cy={204} r={2} fill="currentColor" />
      <path
        stroke="currentColor"
        d="M297.5 193.5h51v51h-51zM227.5.5h85v85h-85z"
      />
      <mask id="a" fill="#fff">
        <path
          fillRule="evenodd"
          d="M71.5 169H128v84.75H71.5V225.5h28.25v-28.25H71.5V169Z"
          clipRule="evenodd"
        />
      </mask>
      <path
        fill="currentColor"
        d="M71.5 169v-1h-1v1h1Zm56.5 0h1v-1h-1v1Zm0 84.75v1h1v-1h-1Zm-56.5 0h-1v1h1v-1Zm0-28.25v-1h-1v1h1Zm28.25 0v1h1v-1h-1Zm0-28.25h1v-1h-1v1Zm-28.25 0h-1v1h1v-1ZM99.75 168H71.5v2h28.25v-2Zm28.25 0H99.75v2H128v-2Zm1 29.25V169h-2v28.25h2Zm0 28.25v-28.25h-2v28.25h2Zm0 28.25V225.5h-2v28.25h2Zm-29.25 1H128v-2H99.75v2Zm0-2H71.5v2h28.25v-2Zm-27.25 1V225.5h-2v28.25h2Zm-1-27.25h28.25v-2H71.5v2Zm27.25-29.25v28.25h2v-28.25h-2Zm-27.25 1h28.25v-2H71.5v2Zm-1-29.25v28.25h2V169h-2Z"
        mask="url(#a)"
      />
      <mask
        id="b"
        width={59}
        height={87}
        x={14}
        y={196.25}
        fill="#000"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M14 196.25h59v87H14z" />
        <path
          fillRule="evenodd"
          d="M15 197.25h56.5v28.25H43.25v28.25H71.5V282H15v-84.75Z"
          clipRule="evenodd"
        />
      </mask>
      <path
        fill="currentColor"
        d="M15 197.25v-1h-1v1h1Zm56.5 0h1v-1h-1v1Zm0 28.25v1h1v-1h-1Zm-28.25 0v-1h-1v1h1Zm0 28.25h-1v1h1v-1Zm28.25 0h1v-1h-1v1Zm0 28.25v1h1v-1h-1ZM15 282h-1v1h1v-1Zm28.25-85.75H15v2h28.25v-2Zm28.25 0H43.25v2H71.5v-2Zm1 29.25v-28.25h-2v28.25h2Zm-29.25 1H71.5v-2H43.25v2Zm1 27.25V225.5h-2v28.25h2Zm-1 1H71.5v-2H43.25v2Zm27.25-1V282h2v-28.25h-2Zm1 27.25H43.25v2H71.5v-2ZM15 283h28.25v-2H15v2Zm-1-29.25V282h2v-28.25h-2Zm0-28.25v28.25h2V225.5h-2Zm0-28.25v28.25h2v-28.25h-2Z"
        mask="url(#b)"
      />
    </svg>
  );
};
export default GroupShape;
